import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FetchCategoriesService } from 'src/app/dashboard/admin/action/components/crm/profile/services/fetch-categories.service';
import { ACTIVATION_STEPS } from 'src/app/shared/activationSteps';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { ActivationStepsService, ActivationStep } from 'src/app/shared/services/activation-steps.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { UpdateActivationStatusService } from 'src/app/shared/services/update-activation-status.service';
import { VerifyFacebook } from 'src/app/shared/services/verify-facebook.service';
import { Validators } from 'src/app/shared/validators';
import Swal from 'sweetalert2';
import * as _ from "lodash-es";
import { GetListOfBanksService } from '../../../financials/services/get-list-of-banks.service';
import { Bank } from '../../../seller';
import { Subscription } from 'rxjs';
import { PostUploadedImageService } from 'src/app/dashboard/admin/action/components/crm/profile/services/post-uploaded-image.service';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { DomSanitizer } from '@angular/platform-browser';
import { AddBankAccountService } from '../../../financials/services/add-bank-account.service';
import { UpdateBusinessInfoService } from 'src/app/dashboard/admin/action/components/crm/profile/services/update-business-info.service';
import { PasswordConfirmComponent } from 'src/app/shared/components/password-confirm/password-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { MissingDataSectionNotifierService } from '../../services/missingDataSectionNotifier.service';
import { GetFacebookVerification } from 'src/app/dashboard/admin/action/components/crm/profile/services/get-facebook-verification.service';
import constantURL from 'src/app/shared/constantURL';

@Component({
  selector: 'app-business-dashboard-check',
  templateUrl: './business-dashboard-check.component.html',
  styleUrls: ['./business-dashboard-check.component.scss']
})
export class BusinessDashboardCheckComponent implements OnInit, AfterViewInit {
  businessForm: FormGroup;
  bankForm: FormGroup;
  businessPage = new FormValidatorService();
  bankPage = new FormValidatorService();
  @Input() businessFields: boolean;
  @Input() facebookFields: boolean;
  @Input() bankFields: boolean;
  @Input() business: IBusiness;

  facebookPattern = /^(https?:\/\/)?(www\.)?facebook.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  pattern = "^[0-9]*";
  charcterPattern = "^[a-zA-Z ]+$";
  selectedFile = null;
  imageSrc = null;
  categoryOptions: { id: string; name: string }[];
  isFacebookVerified: boolean = false;
  banks: Bank[];
  bankBranches: Array<any> = [];
  subscriptions: Subscription[] = [];
  emptyLogo: boolean = false;
  facebookErrorMsg: boolean = false;
  categoryValue:string;
  isLogoValid:boolean=false;
  wasBusinessValid:boolean;
  constructor(
    private translate: TranslateService,
    private fetchCategories: FetchCategoriesService,
    private addBankAccountService: AddBankAccountService,
    private puiS: PostUploadedImageService,
    public activationStepsService: ActivationStepsService,
    private getFacebookVerification: GetFacebookVerification,
    private listBanksService: GetListOfBanksService,
    private ng2ImgMax: Ng2ImgMaxService,
    private verifyFb: VerifyFacebook,
    public sanitizer: DomSanitizer,
    public UpdateActivationStatus: UpdateActivationStatusService,
    public dialog: MatDialog,
    private update: UpdateBusinessInfoService,
    private missingDataSectionNotifer:MissingDataSectionNotifierService
  ) {}

  async ngOnInit() {
    this.businessForm = this.businessPage.createForm([
      {
        fieldName: "name",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: '',
          },
        ],
      },
      {
        fieldName: "logo",
        defaultValue: '',
        validators: [],
      },
      {
        fieldName: "CategoryId",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.required,
            message: "",
          },
        ],
      },
      {
        fieldName: "link_fb",
        defaultValue: "",
        validators: [
          {
            validatorFn: Validators.pattern(this.facebookPattern),
            message: "",
          },
          {
            validatorFn: Validators.required,
            message: "",
          },
        ],
      },
    ]);
    this.bankForm = this.bankPage.createForm([
      {
        fieldName: "bank_id",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: "",
          },
        ],
      },
      {
        fieldName: "BranchId",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: "",
          },
        ],
      },
      {
        fieldName: "holder_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: "",
          },
          {
            validatorFn: Validators.pattern(this.charcterPattern),
            message: "",
          },
        ],
      },
      {
        fieldName: "account_number",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: "",
          },
          {
            validatorFn: Validators.maxLength(32),
            message: "",
          },
          {
            validatorFn: Validators.pattern(this.pattern),
            message: "",
          },
        ],
      },
    ]);
    await this.activationStepsService.setActivationSteps();
    const categories = await this.fetchCategories.make();
    this.banks = await this.listBanksService.make();
    const myOrderedArray = _.sortBy(categories, (o) => o.name);
    this.categoryOptions = myOrderedArray;
    let isbankFormValid=!this.bankFields
    this.wasBusinessValid=!this.businessForm.invalid;
      await this.setData();
    this.isFacebookVerified = await this.getFacebookVerification.make();
    if (this.business.Business['activeStatus'] == 'Verified') {
      if(this.businessForm.invalid || !isbankFormValid || !this.isFacebookVerified || !this.isLogoValid){
      this.businessPage.forceShowErrors();
      this.bankPage.forceShowErrors();
      this.missingDataSectionNotifer.isMissingDataPushNotification(true);
      }else{
      this.missingDataSectionNotifer.isMissingDataPushNotification(false);

      }
    }else{
      this.missingDataSectionNotifer.isMissingDataPushNotification(false);
    }
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.businessPage.validationMessages = {
        "name": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business name',
            fieldAr: 'الاسم التجاري'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Business name',
            fieldAr: 'الاسم التجاري',
            value: 2
          }),
          notInPattern: this.translate.instant('FormValidation.NotInPattern'),
        },
        "CategoryId": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Category',
            fieldAr: 'الفئة'
          }),
        },
        "link_fb": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Facebook link',
            fieldAr: 'رابط الفيسبوك'
          }),
          pattern: this.translate.instant('FormValidation.FacebookPattern'),
        },
      }
      this.bankPage.validationMessages = {
        "bank_id": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Bank',
            fieldAr: 'إسم البنك'
          }),
        },
        "BranchId": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Branch Name',
            fieldAr: 'إسم الفرع'
          }),
        },
        "holder_name": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Account holder name',
            fieldAr: 'اسم صاحب الحساب'
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Account holder name',
            fieldAr: 'اسم صاحب الحساب'
          }),
        },
        "account_number": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Account Number',
            fieldAr: 'رقم الحساب'
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Account Number',
            fieldAr: 'رقم الحساب',
            value: 32
          }),
          pattern: this.translate.instant('FormValidation.Pattern', {
            field: 'Account Number',
            fieldAr: 'رقم الحساب'
          }),
        },
      }
    });
  }

  async setData(): Promise<void> {
    //disable facebook part if varified
    if (!this.facebookFields) this.isFacebookVerified = true;
    this.businessForm.controls["name"].setValue(this.business.Business.name);
    this.businessForm.controls["CategoryId"].setValue(
      this.business.Business.CategoryId
    );
    this.businessForm.controls["link_fb"].setValue(
      this.business.Business.link_fb
    );
    this.imageSrc = this.business.Business.logo;
    if (this.business.Business.logo?.split('%')[0] === constantURL.S3_BUSINESS_LOGO) {
      this.isLogoValid=true;
    }
  }

  facebookVerificationPopup(): void {
    if (!this.isFacebookVerified) {
      Swal.fire({
        title:
          "Please enter the verification code we have sent to you on Facebook",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Verify",
        showLoaderOnConfirm: true,
        preConfirm: async (code) => {
          const result: string = await this.verifyCode(code);
          if (result != "Verified") {
            Swal.showValidationMessage(`${result}`);
          } else {
            this.isFacebookVerified = true;
            this.facebookErrorMsg = false;
            return;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.value as unknown as boolean) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Facebook page verified",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    }
  }

  async verifyCode(code: string): Promise<string> {
    this.verifyFb.setParams({ code });
    const res: IVerifyResponse = await this.verifyFb.make();
    if (res.msg == "Verified") {
      let params: ActivationStep = {
        activationStep: ACTIVATION_STEPS.FACEBOOK_ACTIVATION,
        activationStatus: true,
      };
      this.UpdateActivationStatus.setParams(params);
      let result: Result = await this.UpdateActivationStatus.make();
      if (result.success) {
        this.activationStepsService.setVerifyFacebookStep = params;
      }
    }
    return res.msg;
  }

  onBankSelection(event: any): void {
    // tslint:disable
    const bankBranchesTemp = this.banks.filter(
      (el) => el.id == event.target.value
    );

    // tslint:enable
    const myOrderedArray = _.sortBy(
      bankBranchesTemp[0].Branches,
      (o) => o.english_branch_name
    );
    this.bankBranches = myOrderedArray;
  }

  onFileInput(event): void {
    this.selectedFile = <File>event.target.files[0];
    this.subscriptions.push(
      this.ng2ImgMax.compressImage(this.selectedFile, 0.2, true).subscribe(
        (result) => {
          this.emptyLogo = false;
          const image = new File([result], result.name);
          this.selectedFile = image;
          this.getImagePreview(image);
        },
        (error) => {
          console.log("there is an", error);
        }
      )
    );
  }

  getImagePreview(file: File): void {
    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imageSrc = reader.result;
    };
  }

  async onUploadImage() {
    const fd = new FormData();
    fd.append("image", this.selectedFile);
    console.log(fd);
    this.puiS.setParams(fd);
    try {
      return await this.puiS.uploadImage();
    } catch (errors) {
      console.log(errors);
      throw errors;
    }
  }

  async onSubmit(): Promise<void> {
    await this.checkBusinessChange();
    await this.checkFacebookChange();
    if(this.bankFields){
      await this.checkBankChange();
    }
    if(!this.bankFields){
      if(this.businessForm.valid && this.isFacebookVerified ){
        this.missingDataSectionNotifer.isMissingDataPushNotification(false);
        }
    }
  }
  changeCategory(eve){
      this.businessForm.controls["CategoryId"].setValue(
        eve
      );
    }

    async checkBusinessChange(): Promise<void> {
    //check form fields of errors
    const categoryIdValue=this.businessPage.formGroup.controls['CategoryId'].value;
    const isFound=this.categoryOptions.find(res=>res.id==categoryIdValue);
    if(!isFound){
      this.businessPage.formGroup.controls['CategoryId'].setErrors({required:true})
    }

    if (this.businessForm.invalid) {
      this.businessPage.forceShowErrors();
      return;
    }
    //if the field as a whole is used or no
    if (!this.businessFields && this.wasBusinessValid) return;
    try {
      let businessValues: Business = this.businessForm.value;
      if (!this.imageSrc) {
        this.emptyLogo = true;
        return;
      }
      if (this.selectedFile) {
        const uploadResult = await this.onUploadImage();
        businessValues.logo = uploadResult.location;
      } else {
        //to remove logo and not submit null into the database
        delete businessValues.logo;
      }
      this.update.setParams(businessValues);
      await this.update.make();
    } catch (error) {
      console.log("the error ", error);
    }
  }

  async checkFacebookChange(): Promise<void> {
    //if the form invalid wew return and show errors
    if (this.businessForm.invalid) {
      this.bankPage.forceShowErrors();
      return;
    }
    //if the facebook view is disabled and facebook activation is true return nothing
    if (
      !this.facebookFields &&
      this.activationStepsService.getVerifyFacebookStep
    )
      return;
    //if the facebook view is enabled and activatin step is true disable fields
    if (
      this.facebookFields &&
      this.activationStepsService.getVerifyFacebookStep
    ) {
      this.facebookErrorMsg = false;
      this.isFacebookVerified = true;
    }
    //if the facebook view is enabled and  activation is false inform the user
    if (
      this.facebookFields &&
      !this.activationStepsService.getVerifyFacebookStep
    )
      this.facebookErrorMsg = true;
  }

  async checkBankChange(): Promise<void> {
    //the form is invalid force show error and return
    if (this.bankForm.invalid) {
      this.bankPage.forceShowErrors();
      return;
    }
    //if the view is disabled return nothing
    if (!this.bankFields) return;
    try {
      const dialogRef = this.dialog.open(PasswordConfirmComponent);
      const result = await dialogRef.afterClosed().toPromise();
      if (!result) {
        return;
      }

      const bankAccountFormValues = {
        holder_name: this.bankForm.value.holder_name,
        account_number: this.bankForm.value.account_number,
        BranchId: this.bankForm.value.BranchId,
      };

      this.addBankAccountService.setParams(bankAccountFormValues);
      const newAccount = await this.addBankAccountService.make();
      if(this.businessForm.valid){
      this.missingDataSectionNotifer.isMissingDataPushNotification(false);
      }
      if (newAccount.status == "Pending") {
        Swal.fire({
          icon: "success",
          title: "Successful Request",
          text: `We have sent your bank account request to the admin,
           your bank account will be active once accepted.
            Please don't submit your account again`,
        });
      }
      this.bankForm.disable();
    } catch (error) {
      console.log(error);
    }
  }

  convertBusinessControls(name: string) {
    return this.businessForm.get(name) as FormControl;
  }

  convertBankControls(name: string) {
    return this.bankForm.get(name) as FormControl;
  }
}
//this is the worst code i have written in my life,
//sorry for anyone who have to modify anything after me
interface IVerifyResponse {
  msg: string;
}
interface Result {
  success: boolean;
}
interface IBusiness {
  [key: string]: any;
  Business: Business;
}
interface Business {
  id: number;
  name: string;
  logo: string;
  CategoryId: number;
  link_fb: string;
}
